/* @flow */

import classNames from 'classnames';
import * as React from 'react';
import { Link } from 'react-router-dom';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import styles from './LinkButton.style';

type Props = {
  to: string,
  layoutClass?: string,
  variant?: string,
  children: React.Node,
  onClick?: (Event) => void,
  isExternal?: boolean,
  onMouseOver?: () => void,
  title?: string,
  'aria-label'?: string,
  'data-tip'?: string,
  id?: string,
};

const useStyles = createUseThemeStyles(styles);

const LinkButton = ({
  to,
  children,
  layoutClass,
  onClick,
  variant,
  isExternal,
  onMouseOver,
  title,
  'aria-label': ariaLabel,
  'data-tip': dataTip,
  id,
}: Props): React.Node => {
  const classes = useStyles();
  const rootClasses = classNames(classes.root, layoutClass, {
    [classes.primary]: variant !== 'secondary',
    [classes.secondary]: variant === 'secondary',
  });

  const commonProps = {
    onClick,
    className: rootClasses,
    onMouseOver,
    title,
    'aria-label': ariaLabel,
    'data-tip': dataTip,
    id,
  };

  if (isExternal) {
    return (
      <a {...commonProps} target="_blank" href={to} rel="noreferrer">
        {children}
      </a>
    );
  }

  return (
    <Link {...commonProps} to={to}>
      {children}
    </Link>
  );
};

export default React.memo<Props>(LinkButton);
